'use client';
import React from 'react';

import { useAppSelector, useAppStore, useAppDispatch } from '@/lib/hooks';

import CourseCreatorWizard from '@/common/components/admin/modals/CourseCreatorWizard';
import SelectedAdminCourseView from '@/common/components/admin/SelectedAdminCourseView';
import AllAdminCoursesView from '@/common/components/admin/AllAdminCoursesView';

import { CourseData, CourseId } from 'course-types';

function CoursesPage(): React.JSX.Element {
  const store = useAppStore();
  const dispatch = useAppDispatch();

  const activeCourseData: CourseData = useAppSelector(
    () => store.getState().course.activeCourseData,
  );

  return (
    <main className='w-full h-full'>
      {activeCourseData.id === ('' as CourseId) ? (
        <AllAdminCoursesView />
      ) : (
        <SelectedAdminCourseView />
      )}
      {/* Modal for course creation */}
      <CourseCreatorWizard />
    </main>
  );
}

export default CoursesPage;
